import { ApiEpDatafanToken } from "../../../ep";
let datafanToken = null;
let datafanTokenPromise = null;
export const getDatafanToken = () => datafanToken;
export const setDatafanToken = (token) => {
    datafanToken = token;
    return token;
};
export const refreshDatafanToken = () => {
    if (!datafanTokenPromise) {
        datafanTokenPromise = ApiEpDatafanToken.get();
    }
    return datafanTokenPromise
        .then(({ token }) => setDatafanToken(token))
        .finally(() => {
        datafanTokenPromise = null;
    });
};
//# sourceMappingURL=datafan_token.js.map